import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/management/')({
  loader: () => {
    throw redirect({
      to: '/admin/management/customers',
    })
  },
})
